const constant = {
  file_format_cs21: 'BUYDATA',
  file_format_rst_data: 'RSTDATA',
  API_AVAILABLE: 1,
  API_NOT_AVAILABLE: 0,
};

export default constant;
